import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter, map, tap} from 'rxjs/operators';

import {EventBusPort} from '@platform/event-bus/domain/ports/event-bus.port';
import {distinctUntilChanged} from "rxjs";
import {CurrentWaiterUpdatedEvent} from "@core/entities/waiter/event/current-waiter-updated";
import {WaiterSwitchedEvent} from "@platform/event-bus/domain/events/waiter/waiter-switched.event";

@Injectable({providedIn: 'root'})
export class PlatformOnCurrentWaiterUpdatedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EventBusPort);

  constructor() {
    this.eventBus
      .ofType(CurrentWaiterUpdatedEvent)
      .pipe(
        map(event => event.waiter?._id),
        filter((waiterId): waiterId is string => !!waiterId),
        distinctUntilChanged(),
        tap(waiterId => this.eventBus.publish(new WaiterSwitchedEvent({waiterId})),),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
